import React from 'react';

// Section components
import HeroSection from '../components/sections/HeroSection';
import LogoRailSection from '../components/sections/LogoRailSection';
import ServicesSection from '../components/sections/ServicesSection';
import NichesSection from '../components/sections/NichesSection';
import WorkflowsSection from '../components/sections/WorkflowsSection';
import SkillsSection from '../components/sections/SkillsSection';
import StudioSection from '../components/sections/StudioSection';
import ProjectsSection from '../components/sections/ProjectsSection';
import ResumeSection from '../components/sections/ResumeSection';
import BlogSection from '../components/sections/BlogSection';
import ContactSection from '../components/sections/ContactSection';

const HomePage: React.FC = () => {
  return (
    <>
      <HeroSection />
      <LogoRailSection />
      <ServicesSection />
      <ProjectsSection />
      <NichesSection />
      <WorkflowsSection />
      <SkillsSection />
      <StudioSection />
      <ResumeSection />
      <BlogSection />
      <ContactSection />
    </>
  );
};

export default HomePage;
